const React = require('react');
const {openPopupWindow} = require('../../../../../../../emitters/popup');
const Popup = require('../../../../../../dumb/Popup/C');
const FormActivateRetailer = require("../components/FormActivateRetailer");

module.exports = ({account_id}) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Activate Retailer</div>
          </div>
        )}
      >
        <div className="mt20">Please, select the legal entity you want to associate with this retailer.</div>
        <FormActivateRetailer account_id={account_id} close={close} />
      </Popup>
    );
  };
});
